import React from 'react';
import { createSelector, Selector } from 'reselect';

import { SpacesSiteUrls } from '../spaces/SpacesSiteUrls';
import { AppState } from '../state/AppState';
import { MapStateToProps } from '../utils/ConnectUtils';
import { selectSessionSite } from './SessionInfoSelectors';
import { queryStringSelector } from './QueryStringSelectors';

export interface SiteUrlsProps {
  urls: SpacesSiteUrls;
}

export const siteUrlsSelector: Selector<AppState, SpacesSiteUrls> = createSelector(
  selectSessionSite,
  queryStringSelector,
  // Some code, including populateContentBreadcrumbs, expect SpacesSiteUrls to be falsy
  // when there's no session (and hence no session site).  This preserves that behavior.
  (site, queryString) => site ? new SpacesSiteUrls({ siteUrlName: site.urlName, queryString }) : null
);

export const mapStateToSiteUrlsProps: MapStateToProps<SiteUrlsProps> =
  (state: AppState): SiteUrlsProps => ({
    urls: siteUrlsSelector(state)
  });
